export class ModalHook {
    constructor() {
        this.events = [];
    }
    getData() {
        return this.data;
    }
    on(event, callback) {
        this.events.push({ name: event, callback: callback });
    }
    raise(event) {
        this.events.forEach(x => {
            if (x.name !== event)
                return;
            x.callback();
        });
    }
    open(data) {
        this.data = data;
        this.raise("open");
        return new Promise((resolve, _) => {
            this.resolve = resolve;
        });
    }
    close(result) {
        this.raise("close");
        this.resolve(result);
    }
}
